
export const config = {
  dev: {
    // Base Url of the API host, i.e. https://api.somesite.com
    // if different than the SPA host. Leave blank if same
    baseUrl: 'https://localhost:50083',

    // Base Url of the Identity Server host, i.e. https://login.somesite.com
    // if different than the SPA host. Leave blank if same
    baseIDSUrl: 'https://localhost:61024',

    // Hosted application path to root of the application 
    // Set / for root or add the app path i.e. /someapp
    // where the application was hosted in the application someapp
    // in the default website for example
    appName: '/',

    // Time out value (in milliseconds) for calls from the http service to
    // the backend API
    httpApiServiceTimeOut: 30000,

    // Attempt to refresh JWT token if expired - JWT Bearer Authentication only
    attemptTokenRefresh: true,

    // Set the UI theme to use from the stylesheets, these are set per site:
    // qQkCE4Xe - K , sj5xkM6L - B , 78sh335p - FF DEMO, fNc54H2J - FNC, vall41JU - Valley Wholesale
    theme: 'qQkCE4Xe',

    // The window title prefix that the SPA will use
    documentTitlePrefix: 'Realitex200 test E-commerce',

    localStorageCipherKey: 'bEq=c-FLfyLFn7VNhzjBAsbD3?uUj%Hq',

    //was set in WBSECommerceSetup but between the fetch and the push to the table it kept dissapearing
    singleOrderOnlyPayment: true,

    // WorldPay Client API key if using WorldPay Online Payments gateway
    worldPayClientKey: 'CHANGEMEifWorldPayIsUsed',

    //all Opayo props needed to make online payments

    //CDN link to script that Opayo uses - different in test vs live
    opayoScriptSource: 'https://pi-test.sagepay.com/api/v1/js/sagepay.js',
    opayoApiBaseUrl: 'https://pi-test.sagepay.com/api/v1',

    //opayo props required for posting after the 3D secure result is gotten 
    opayoPaymentChallengeUrlTransactionKey: "{transactionId}",
    opayoPaymentChallengeUrl: "https://pi-test.sagepay.com/api/v1/transactions/{transactionId}/3d-secure-challenge",


    //#region backup of sandbox Opayo auth details
    //opayoVendorName: 'sandboxEC',
    //opayoIntegrationKey: 'dq9w6WkkdD2y8k3t4olqu8H6a0vtt3IY7VEsGhAtacbCZ2b5Ud',
    //opayoIntegrationPassword: 'hno3JTEwDHy7hJckU4WuxfeTrjD0N92pIaituQBw5Mtj7RG3V8zOdHCSPKwJ02wAV',

    // Alternative credentials -  don't require e.g. 3D security - but need updating on server also to make work, better way is to just force to use 3D security serverside
    // opayoVendorName: 'sandbox',
    // opayoIntegrationKey: 'hJYxsw7HLbj40cB8udES8CDRFLhuJ8G54O6rDpUXvE6hYDrria',
    // opayoIntegrationPassword: 'o2iHSrFybYMZpmWOQMuhsXP52V4fBtpuSDshrKDSWsBY1OiN6hwd9Kb12z4j5Us5u',
    //#endregion
    UseWebApiForStockPieceAllocation: true




  },

  build: {
    // Base Url of the API host, i.e. https://api.somesite.com
    // if different than the SPA host. Leave blank if same
    baseUrl: 'https://ecomm.api.floorsncarpetsltd.co.uk',

    // Base Url of the Identity Server host, i.e. https://login.somesite.com
    // if different than the SPA host. Leave blank if same
    baseIDSUrl: 'https://login.floorsncarpetsltd.co.uk',

    // Hosted application path to root of the application
    // Set / for root or add the app path i.e. /someapp
    // where the application was hosted in the application someapp
    // in the default website for example
    appName: '/',

    // Time out value (in milliseconds) for calls from the http service to
    // the backend API
    httpApiServiceTimeOut: 30000,

    // Attempt to refresh JWT token if expired - JWT Bearer Authentication
    attemptTokenRefresh: true,

    // Set the UI theme to use from the stylesheets, these are set per site:
    //78sh335p - FF DEMO,  qQkCE4Xe - K , sj5xkM6L - B, fNc54H2J - FNC, vall41JU - Valley Wholesale
    theme: 'fNc54H2J',

    // The window title prefix that the SPA will use
    documentTitlePrefix: 'Realitex200 E-commerce',

    localStorageCipherKey: '?FAHv&6MnwG54GW_WYntqAEKn!VegB!$',

    //was set in WBSECommerceSetup but between the fetch and the push to the table it kept dissapearing
    singleOrderOnlyPayment: true,

    // WorldPay Client API key if using WorldPay Online Payments gateway
    worldPayClientKey: 'CHANGEMEifWorldPayIsUsed',

    //CDN link to script that Opayo uses - different in test vs live
    opayoScriptSource: 'https://pi-test.sagepay.com/api/v1/js/sagepay.js',
    opayoApiBaseUrl: 'https://pi-test.sagepay.com/api/v1',

    //all Opayo props needed to make online payments
    opayoVendorName: '',
    opayoIntegrationKey: '',
    opayoIntegrationPassword: '',

    //opayo props required for posting after the 3D secure result is gotten 
    opayoPaymentChallengeUrlTransactionKey: '{transactionId}',
    opayoPaymentChallengeUrl: 'https://pi-test.sagepay.com/api/v1/transactions/{transactionId}/3d-secure-challenge',
    UseWebApiForStockPieceAllocation : true,
  },

  version: '1.3.27'
}


